import { FC } from 'react';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import classNames from 'classnames';
import AdvertListFilterControlsCss from '#srcCssModules/advert/list-filter/advert-list-filter-controls.module.scss';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';

const FilterItemList: FC = () => {
  const { filterItemList, hideDetail } = useFilterContext();

  return filterItemList.map((filterItem) => (
    <Button
      key={filterItem.link.to}
      variant={ButtonVariant.unstyled}
      navLinkProps={{
        to: filterItem.link.to,
        state: filterItem.link.state,
        end: true,
        onClick: () => {
          hideDetail();
        },
        className: ({ isActive }) => classNames(
          AdvertListFilterControlsCss.advertListFilterControls__action,
          { [AdvertListFilterControlsCss.advertListFilterControls__action_active]: isActive },
        ),
      }}
      dataAttributeList={{
        url: filterItem.link.to,
        ...filterItem.link.state.routerConfig,
      }}
    >
      {filterItem.getVisibleTitle()}
    </Button>
  ));
};

export { FilterItemList };
